import { useCallback, useRef } from 'react';

type UseAccordionKeyboardNavigationProps = {
  onToggle?: () => void;
  disabled?: boolean;
};

export const useAccordionKeyboardNavigation = ({
  onToggle,
  disabled = false,
}: UseAccordionKeyboardNavigationProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLButtonElement>) => {
      if (disabled) return;

      const { key } = event;
      const currentButton = event.currentTarget;
      const accordionContainer = currentButton.closest('.accordion-container');

      if (!accordionContainer) return;

      const allButtons = Array.from(
        accordionContainer.querySelectorAll('button[aria-expanded]')
      ) as HTMLButtonElement[];

      const currentIndex = allButtons.indexOf(currentButton);

      switch (key) {
        case 'ArrowDown':
        case 'ArrowRight': {
          event.preventDefault();
          const nextIndex = (currentIndex + 1) % allButtons.length;
          allButtons[nextIndex]?.focus();
          break;
        }
        case 'ArrowUp':
        case 'ArrowLeft': {
          event.preventDefault();
          const prevIndex =
            currentIndex === 0 ? allButtons.length - 1 : currentIndex - 1;
          allButtons[prevIndex]?.focus();
          break;
        }
        case 'Home': {
          event.preventDefault();
          allButtons[0]?.focus();
          break;
        }
        case 'End': {
          event.preventDefault();
          allButtons[allButtons.length - 1]?.focus();
          break;
        }
        case 'Enter':
        case ' ': {
          event.preventDefault();
          onToggle?.();
          break;
        }
      }
    },
    [onToggle, disabled]
  );

  return {
    buttonRef,
    handleKeyDown,
  };
};
